// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";

// import reportWebVitals from './reportWebVitals';

// import './index.css';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>

//       <App />

//   </React.StrictMode>
// );
// reportWebVitals();

/**
 * ─────────────────────────────────────────────
 * src/index.js  (REPLACE your existing index.js)
 * ─────────────────────────────────────────────
 *
 * WHY WE ADD <Provider store={store}>:
 *
 * Provider is from react-redux.
 * It makes the Redux store available to EVERY component in the app.
 * Without it, useSelector and useDispatch hooks won't work.
 *
 * Think of it like a "context wrapper" —
 * any component inside <Provider> can access the store.
 *
 * This is the ONLY place where you import the store and connect it to React.
 * You never import the store directly in components — use useSelector instead.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux"; // ← This connects Redux to React
import store from "./store"; // ← Your configured Redux store
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {/*
      Provider wraps your entire App.
      Every component inside can now use useSelector() and useDispatch().
      store={store} is the Redux store we built in src/store/index.js
    */}
    <Provider store={store}>
      {/* Catches render-time errors so one broken component shows a recovery
          screen instead of blanking the entire app. */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
